import { Button } from "@minervaproject/fds";
import clsx from "clsx";

import { TooltipErrorBoundary } from "components/error_boundary";
import { BreakoutTimeRemaining } from "components/shared/timers";
import { useCapability } from "hooks/capabilities";
import { useAppDispatch, useAppSelector } from "hooks/redux_hooks";
import { adjustBreakoutSessionDuration, endBreakoutSession } from "shared/reducers/classroom";
import { CapabilityType } from "shared/types";
import { classroomSelectors } from "store";

function BreakoutControls({ breakoutSessionId }: { breakoutSessionId: string }) {
  const dispatch = useAppDispatch();
  const breakoutSession = useAppSelector(
    classroomSelectors.selectBreakoutSessionById(breakoutSessionId),
  );
  const canControlClassroom = useCapability(CapabilityType.CAN_CONTROL_CLASSROOM);

  const handleEndBreakoutSession = () => {
    dispatch(endBreakoutSession());
  };

  const handleAddOneMinuteToBreakout = () => {
    dispatch(adjustBreakoutSessionDuration({ id: breakoutSessionId, timeAdjustmentInSeconds: 60 }));
  };

  const isBreakoutTimed = !!breakoutSession.ended_on;

  return (
    <div className="flex justify-between">
      {canControlClassroom && (
        <Button
          kind="text"
          className="text-button-classroom-secondary py2 pr4 end-breakout-button"
          onClick={handleEndBreakoutSession}
        >
          {/* TODO: Add the breakout stop icon here if the icon is kept in the updated design */}
          End Breakout
        </Button>
      )}
      {isBreakoutTimed && (
        <div className="flex items-center py2 breakout-control-room__time">
          <span className={clsx("body-xs bold text-white mr2", { pr2: !canControlClassroom })}>
            <TooltipErrorBoundary text="The remaining time cannot be displayed">
              <BreakoutTimeRemaining breakoutSessionId={breakoutSessionId} />
            </TooltipErrorBoundary>
          </span>
          {canControlClassroom && (
            <Button
              kind="text"
              className="text-button-classroom-secondary pr4"
              onClick={handleAddOneMinuteToBreakout}
            >
              Add 1 min
            </Button>
          )}
        </div>
      )}
    </div>
  );
}

export { BreakoutControls };
